import React from 'react';
import classNames from '../../../../utility/classNames';
import { checkCondition } from '../../utility/filterSchema';
import LegacyCalculations from './LegacyCalculated';
import TwoColumnSection from './TwoColumnSection';
import BeforeAfterCalculationsSection from './BeforeAfterCalculationsSection';
import ChartSection from './ChartSection';
import BannerSection from './ConditionalBannerSection';
import DiagramSection from './DiagramSection';

export default function CalculatedSection({
  sectionSchema,
  data,
  first,
  onReportClick = () => {},
}) {
  const { sectionCondition, layoutClasses, sectionType } = sectionSchema;

  if (sectionCondition) {
    const conditionMet = checkCondition(sectionCondition, data);
    if (!conditionMet) return null;
  }

  const sectionSwitch = (type) => {
    switch (type) {
      case 'twoColumn':
        return (
          <TwoColumnSection
            onReportClick={onReportClick}
            section={sectionSchema}
            data={data}
          />
        );
      case 'beforeAfter':
        return (
          <BeforeAfterCalculationsSection section={sectionSchema} data={data} />
        );
      case 'chart':
        return <ChartSection section={sectionSchema} data={data} />;
      case 'banner':
        return <BannerSection section={sectionSchema} data={data} />;
      case 'diagram':
        return <DiagramSection section={sectionSchema} data={data} />;
      default:
        return <LegacyCalculations section={sectionSchema} data={data} />;
    }
  };

  return (
    <div
      className={classNames(
        layoutClasses,
        'rounded-lg relative col-span-4 mb-10',
        first ? 'mb-10' : 'last:mb-0',
        sectionType === 'twoColumn' ? 'bg-transparent' : 'bg-white'
      )}
    >
      {/* <div className="absolute rounded-t top-0 left-0 w-full h-[3px] bg-primary-400 z-10"></div> */}
      {sectionSwitch(sectionType)}
    </div>
  );
}
